import { FETCH_USER_PROFILE, ADD_FRIEND_SUCCESS, REMOVE_FRIEND_SUCCESS } from './types'
import { objectReducer } from 'utils'

const userProfile = objectReducer(
  FETCH_USER_PROFILE,
  {},
  {
    extra: (state, { type, user }) => {
      if ((type == ADD_FRIEND_SUCCESS || type == REMOVE_FRIEND_SUCCESS) && user.id == state.id) {
        return { ...state, inHotlist: type === ADD_FRIEND_SUCCESS }
      }
      return state
    },
  }
)

export default userProfile
